<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Data</b-card-title>
      </b-card-header>

      <b-card-body>
        <b-row>
          <b-col
            cols="8"
            offset-md="2"
          >
            <h4>Filter</h4>
            <b-form
              class="needs-validation"
              @submit.prevent="submitFilter"
            >
              <b-row>
                <b-col cols="6">
                  <b-form-group
                    label="Tahun"
                    label-for="tahunFilter"
                  >
                    <b-form-select
                      id="tahunFilter"
                      v-model="tahunFilter"
                      :options="dataTahun"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Wilayah"
                    label-for="wilayahFilter"
                  >
                    <b-form-select
                      id="wilayahFilter"
                      v-model="wilayahFilter"
                      :options="dataWilayah"
                      :disabled="!$can('Filter', 'cetakBarcode')"
                      @change="changeWilayah"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="KIB"
                    label-for="kibFilter"
                  >
                    <b-form-select
                      id="kibFilter"
                      v-model="kibFilter"
                      :options="dataKib"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Ukuran"
                    label-for="ukuranFilter"
                  >
                    <b-form-select
                      id="ukuranFilter"
                      v-model="ukuranFilter"
                      :options="dataUkuran"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    label="PD/UPD"
                    label-for="pdUpdFilter"
                  >
                    <v-select
                      id="kolok"
                      v-model="pdUpdFilterValue"
                      label="text"
                      :options="dataPdUpd"
                      :disabled="!$can('Filter', 'cetakBarcode')"
                      @search="searchPdUpd"
                      @input="inputPdUpd"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-col
                cols="12"
                align="right"
                class="pr-0"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  size="sm"
                  type="submit"
                  :disabled="!pdUpdFilter"
                >
                  Lihat
                </b-button>
              </b-col>
            </b-form>
          </b-col>
          <b-col
            cols="12"
            class="mt-2"
          >
            <b-row>
              <b-col
                v-for="(item, index) of barcodes"
                :key="index"
                cols="3"
                class="mb-2"
                align="center"
              >
                <b-img
                  class="mb-sm-0"
                  height="120"
                  :src="item"
                  alt="Left image')"
                />
              </b-col>
            </b-row>
            <!-- table -->
          </b-col>
        </b-row>
        <div
          id="showPdf"
          class="mb-2"
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BButton,
  BFormGroup,
  BFormSelect,
  BForm,
  BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import moment from 'moment'
import vSelect from 'vue-select'
import master from '@/composables/master'
import { generateYears, startYear } from '@/libs/helper'

export default {
  setup(props, context) {
    // global variable
    const g = context.root
    const { $route } = g

    const year = moment().format('YYYY')

    const tahunFilter = ref($route.query.tahun || year)
    const pdUpdFilter = ref($route.query['pd-upd'] || '')
    const pdUpdFilterValue = ref({ text: '-- Pilih Salah Satu --', value: '' })
    const wilayahFilter = ref($route.query.wilayah || '')
    const kibFilter = ref($route.query.kib || 'C')
    const ukuranFilter = ref($route.query.ukuran || 1)

    const cookiesJenisAkun = ref(g.$cookies.get('jenisAkun'))

    if (cookiesJenisAkun.value == 'D' || cookiesJenisAkun.value == 'F') {
      const cookiesNalok = ref(g.$cookies.get('nalok'))
      const cookiesKolok = ref(g.$cookies.get('kolok'))
      const cookiesWilayah = ref(g.$cookies.get('wilayah'))
      pdUpdFilterValue.value = {
        text: `${cookiesKolok.value}::${cookiesNalok.value}`,
        value: cookiesKolok.value,
      }
      pdUpdFilter.value = cookiesKolok.value
      wilayahFilter.value = cookiesWilayah.value
    }

    const dataTahun = ref(generateYears(startYear, year))
    const dataWilayah = ref([{ text: '-- Semua --', value: '' }])
    const dataPdUpd = ref([{ text: '-- Pilih Salah Satu --', value: '' }])
    const dataProvinsi = ref([])
    const dataKecamatan = ref([])
    const dataKelurahan = ref([])
    const dataKib = ref([{ text: '-- Semua --', value: '' }])
    const dataUkuran = ref([
      { text: '6.5 x 10', value: 1 },
      // {text: '15 x 10', value: 2}
    ])

    const barcodes = ref([])

    const submitFilter = async () => {
      let width = 100
      let height = 65
      if (ukuranFilter.value == 1) {
        width = 100
        height = 65
      } else {
        width = 100
        height = 150
      }

      window.open(
        `https://jakaset.jakarta.go.id/${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/list-barcode?filter_upd=${pdUpdFilter.value}&filter_kib=${kibFilter.value}&format=pdf&width=${width}&height=${height}&length=1000000`,
        '_blank',
      )
    }

    const getWilayah = async () => {
      const resWilayah = await master.getWilayah(g)
      resWilayah.unshift({ text: '-- Semua --', value: '' })

      dataWilayah.value = resWilayah
    }

    const getKib = async () => {
      const resKib = await master.getKib(g)
      resKib.unshift({ text: '-- Pilih Salah Satu --', value: '' })
      dataKib.value = resKib
    }

    getWilayah()
    getKib()

    const getPdUpd = async (searchPdUpd = '') => {
      const params = {
        tahun: tahunFilter.value,
        cari: searchPdUpd,
        wilayah: wilayahFilter.value,
      }
      const resPdUpd = await master.getPdUpd(g, params)
      resPdUpd.unshift({ text: '-- Pilih Salah Satu --', value: '' })
      dataPdUpd.value = resPdUpd
    }

    const changeWilayah = () => {
      if (wilayahFilter.value) {
        pdUpdFilter.value = ''
        pdUpdFilterValue.value = { text: '-- Pilih Salah Satu --', value: '' }
      }
      getPdUpd()
    }

    const searchPdUpd = async search => {
      getPdUpd(search)
    }

    const inputPdUpd = () => {
      if (pdUpdFilterValue.value) pdUpdFilter.value = pdUpdFilterValue.value.value
    }

    getPdUpd()

    return {
      tahunFilter,
      pdUpdFilter,
      barcodes,
      kibFilter,
      wilayahFilter,
      pdUpdFilterValue,
      ukuranFilter,
      dataTahun,
      dataWilayah,
      dataPdUpd,
      dataProvinsi,
      dataKecamatan,
      dataKelurahan,
      dataKib,
      dataUkuran,
      submitFilter,
      changeWilayah,
      searchPdUpd,
      inputPdUpd,
    }
  },
  components: {
    vSelect,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BFormGroup,
    BFormSelect,
    BForm,
    BImg,
  },
  directives: {
    Ripple,
  },
  props: {
    page: { type: String, default: '' },
  },
  data() {
    return {
      columns: [
        {
          label: 'No',
          field: 'no',
          width: '1%',
        },
        {
          label: 'Kode',
          field: 'kode',
        },
        {
          label: 'Url',
          field: 'url',
        },
        {
          label: 'Aksi',
          field: 'aksi',
          width: '1%',
          sortable: false,
        },
      ],
    }
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
.pdfobject-container {
  height: 80rem;
  border: 1rem solid rgba(0, 0, 0, 0.1);
}
</style>
